import { createFileRoute } from "@tanstack/react-router";
import { redirectIntoScope } from "@/app/router/legacy-redirect";

/** Old unscoped URL: `/imports/…` → `/{store}/imports/…`. */
export const Route = createFileRoute("/imports/$")({ beforeLoad: redirectIntoScope });
